import View from "backdraft-app/src/view";

import Select from "../select";

import "../jquery/icon";

import "vendor/bootstrap";

import $ from "jquery";

export default function monkeyPatchBaseView() {
  // extend View's initialize to always wire up select2's after render
  const oldInitialize = View.prototype.initialize;

  View.prototype.initialize = function() {
    if (oldInitialize) {
      oldInitialize.apply(this, arguments);
    }
    this.on("afterSwap", function() {
      // Convert any select tags to a select2
      Select.convertAll(this.$el);

      // Trigger bootstrap tooltip for any data-toggle=tooltip
      $('.popover').popover('hide');
      $('[data-toggle=tooltip]').tooltip('hide');
      $('[data-toggle="tooltip"]').tooltip();

      // Convert any data-icons to an icon
      if ($.fn.icon) {
        this.$el.icon();
      }
    });
  };
}
